import { createSlice } from '@reduxjs/toolkit'
import { AuditState } from '../types/audit.types'

const initialState: AuditState = {
  viewrolesAuditHistoryData: [],
  hasMore: true,
  page: -1,
  metaData: {
    id: 0,
    name: '',
    table_name: '',
    plural_label: '',
    singular_label: '',
  },
}

const auditSlice = createSlice({
  name: 'audit',
  initialState: initialState,
  reducers: {
    updateAuditHistoryData: (state: AuditState, action) => {
      state.viewrolesAuditHistoryData = [
        ...state.viewrolesAuditHistoryData,
        ...action.payload,
      ]
    },
    updateHasMore: (state: AuditState, action) => {
      state.hasMore = action.payload
    },
    updateAuditHistoryMetaData: (state: AuditState, action) => {
      state.metaData = action.payload
    },
    incrementPageNo: (state: AuditState) => {
      state.page = state.page + 1
    },
    resetAuditState: (state: AuditState) => {
      state.page = -1
      state.hasMore = true
      state.viewrolesAuditHistoryData = []
    },
    getAuditHistoryAction: () => {
      return
    },
    getAuditHistoryMetaDataAction: () => {
      return
    },
  },
})

export const {
  updateAuditHistoryData,
  getAuditHistoryAction,
  updateAuditHistoryMetaData,
  getAuditHistoryMetaDataAction,
  resetAuditState,
  incrementPageNo,
  updateHasMore,
} = auditSlice.actions
export default auditSlice.reducer
